"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _reactRedux = require("react-redux");

var _clsx = _interopRequireDefault(require("clsx"));

var _componentEngine = require("@mmc-tools/component-engine");

var _commonErrorBoundary = require("@mmc/common-error-boundary");

var _pageSwitch = _interopRequireDefault(require("../styles/page-switch.css"));

var _tabButton = _interopRequireDefault(require("./tab-button"));

var _subComponent = _interopRequireDefault(require("./sub-component"));

var _pageSwitch2 = _interopRequireDefault(require("./page-switch.props/page-switch.defaultProps"));

var _pageSwitch3 = _interopRequireDefault(require("./page-switch.props/page-switch.propTypes"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * ## PageSwitch - component
 *
 * A set of tabs that switch between different components they load in
 */
// We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps; // This component needs the component engine to work, so it can only be tested inside of the component engine during dev

var PageSwitch = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(PageSwitch, _React$Component);

  PageSwitch.resourceType = function resourceType() {
    return 'PageSwitch_1_0_0';
  };

  PageSwitch.checkSelectedTab = function checkSelectedTab(currentIndex, selectedIndex) {
    return currentIndex === selectedIndex;
  };

  function PageSwitch(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      selectedIndex: 0
    };
    _this.updateSelectedIndex = _this.updateSelectedIndex.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = PageSwitch.prototype;

  _proto.getComponents = function getComponents(componentsFromData, theme, restProps) {
    var components = componentsFromData.components;

    if (!components) {
      return null;
    }

    var ComponentMap = new _componentEngine.ComponentMapper();
    var appMode = restProps.appMode,
        path = restProps.path;
    var compProps = restProps;
    compProps.pathFromPageSwitch = path;

    if (appMode === 'preview' && path.includes('/content/mitsubishi-motors')) {
      compProps.pathFromPageSwitch = path.split('/content/mitsubishi-motors').pop();
    }

    var componentsWithErrorBoundary = ComponentMap.componentMapper(components, theme, compProps).map(function (component, idx) {
      return /*#__PURE__*/_react["default"].createElement(_commonErrorBoundary.CommonErrorBoundary, {
        errorMsg: components[idx].resourceType + " at index " + idx + " has caught an error",
        key: components[idx].resourceType + "_" + idx
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: components[idx].resourceType + "_" + idx
      }, component));
    });
    return componentsWithErrorBoundary;
  } // We will use this to update some internal state that keeps track of the currently selected tab
  ;

  _proto.updateSelectedIndex = function updateSelectedIndex(index) {
    this.setState(function () {
      return {
        selectedIndex: index
      };
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        data = _this$props.data,
        theme = _this$props.theme,
        defaultData = _this$props.defaultData; // first we select the data from the larger query coming through

    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    var tabs = componentData.tabs;
    var selectedIndex = this.state.selectedIndex;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme['container-fluid'], _pageSwitch["default"].pageSwitch),
      automation: "PageSwitch Container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme.row, _pageSwitch["default"].noGutters)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme['col-xs-12'], _pageSwitch["default"].buttonContainer)
    }, tabs && tabs.map(function (tab, i) {
      return /*#__PURE__*/_react["default"].createElement(_tabButton["default"], {
        key: tab.label,
        index: i,
        tab: tab,
        selectedIndex: selectedIndex,
        updateSelectedIndex: _this2.updateSelectedIndex,
        checkSelectedTab: PageSwitch.checkSelectedTab,
        theme: theme
      });
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme['col-xs-12'], _pageSwitch["default"].subComponentContainer)
    }, tabs && tabs.map(function (tab, i) {
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
        key: tab.label
      }, PageSwitch.checkSelectedTab(selectedIndex, i) && /*#__PURE__*/_react["default"].createElement(_subComponent["default"], (0, _extends2["default"])({
        tab: tab,
        theme: theme,
        getComponents: _this2.getComponents
      }, _this2.props)));
    }))));
  };

  return PageSwitch;
}(_react["default"].Component);

PageSwitch.displayName = 'PageSwitch';
PageSwitch.defaultProps = {
  data: _pageSwitch2["default"],
  defaultData: _pageSwitch2["default"],
  theme: {}
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    appMode: state.appMode
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(PageSwitch);

exports["default"] = _default;